import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setTaxCounty, setSalesTaxConsole } from '../../redux/modules/salestaxes';
import Dropdown from '../../components/Dropdown';
import counties from '../../modules/data/counties';
import countyTaxTotal from '../../selectors/countyTaxTotal.selector';
import TextInput from '../../components/TextInput';

class CountyDiscretionaryTax extends Component {
  constructor(props) {
    super(props);
    this.onCountySelect = this.onCountySelect.bind(this);
  }

  onCountySelect(event) {
    const value = event.target.value;
    const parts = value.split('|');
    this.props.setTaxCounty(parts[0], parts[1], value);
  }

  render() {
    const { countyDiscretionaryTax, taxCountySelectedValue, taxCountyFee, taxCountyName } = this.props;
    return (
      <div className="Row Title-feeRow">

        <TextInput
          value={countyDiscretionaryTax || '0.00'}
          readOnly
          className="Row-total"
          tabIndex="-1"
        />

        <Dropdown
          id="County"
          data-id="taxCounty"
          data-tooltip="Choose your Florida county of residence. The residence address of the purchaser identified on the title or registration is used to determine the correct county discretionary tax required."
          options={counties}
          selectedValue={taxCountySelectedValue}
          onChange={this.onCountySelect}
          className="Dropdown Row-dropdown State-dropdown no-print"
        />

        <b className="no-print">Discretionary Tax County Fee</b>
        <b className="print-label print-only">{taxCountyName} County Tax</b>&nbsp;
        <span className="Row-subtext">{taxCountyFee ? ` Sales Price * ${taxCountyFee}` : ''}</span>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    taxCountyFee: state.salestaxes.taxCountyFee,
    taxCountyName: state.salestaxes.taxCountyName,
    taxCountySelectedValue: state.salestaxes.taxCountySelectedValue,
    countyDiscretionaryTax: countyTaxTotal(state),
  };
};

export default connect(mapStateToProps, { setTaxCounty, setSalesTaxConsole })(CountyDiscretionaryTax);
